// @ts-nocheck

export const localeCodes =  [
  "br"
]
export const localeLoaders = {
  br: [
    {
      key: "locale_pt_45br_46json_d04e2fb1",
      load: () => import("#nuxt-i18n/d04e2fb1" /* webpackChunkName: "locale_pt_45br_46json_d04e2fb1" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "br",
    language: undefined
  }
]

